import {
  EventEmitter,
  HostListener,
  OnChanges,
  Output,
  Renderer2,
} from "@angular/core";
import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FreightsRequestDto } from "../../../../core/models/bcLedgers/freightsRequestDto";
import { FreightsData } from "../../../../core/models/bcLedgers/freightsResponseDto";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { Table, TableModule } from "primeng/table";
import { BcLedgerStacker } from "../../../../core/models/bcLedgers/bcLedgerStacker";
import { LoaderService } from "../../../../core/services/loader.service";
import { exportExcel } from "../../../../core/services/shared.service";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { MoveToFreightComponent } from "../move-to-freight/move-to-freight.component";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { FreightDetailsComponent } from "../freight-details/freight-details.component";
import { BcledgerService } from "../../../../core/services/bcledger.service";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";

@Component({
  selector: "jni-freight",
  templateUrl: "./freight.component.html",
  styleUrls: ["./freight.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    HidedynamicsdatePipe,
    MoveToFreightComponent,
    ModalStackerComponent,
    FreightDetailsComponent,
    ButtonModule,
    InputTextModule,
    SpinnerComponent,
  ],
})
export class FreightComponent implements OnInit, OnChanges {
  @Input() bcLedgerStacker!: BcLedgerStacker;
  freightLists: FreightsData[] = [];
  frieghtsSelected!: FreightsData;
  freightsParams!: FreightsRequestDto;
  total!: number;
  display = false;
  fileName = "Freight";
  trackingDisplayModal = false;
  trackingNumber = "";
  showfilter = true;
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _freightService: BcledgerService,
    private _toastrService: JniToastrService,
    private _loaderService: LoaderService,
    private renderer: Renderer2
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.freightsParams = { ...params } as FreightsRequestDto;
    });
  }

  ngOnInit(): void {
    this.getFreights(this.freightsParams);
  }

  getFreights(payload: FreightsRequestDto) {
    this._loaderService.setLoaderState(true);
    this._freightService.freights(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.freightLists = res.data.Data ?? [];
          this.total = res.data.Total;
          return;
        }
        this._toastrService.error(
          res.message ?? "Freights Fetched",
          "Freights"
        );
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastrService.error("No results found", "Error");
      },
    });
  }

  clearTable(table: Table) {
    table.clearFilterValues();
    table.clear();
  }

  moveToFreight() {
    this.display = true;
  }

  moveToFreightEvent(event: boolean) {
    if (event) {
      this.getFreights(this.freightsParams);
    }
    this.display = false;
    this.frieghtsSelected = {} as FreightsData;
  }

  exportExcelFile() {
    exportExcel(this.freightLists, this.fileName);
  }

  ngOnChanges() {
    if (this.bcLedgerStacker) {
      this.freightsParams = { ...this.bcLedgerStacker };
    }
  }

  closeModalOnTrackingPage() {
    this.trackingDisplayModal = false;
  }

  redirectToTrackingSummary(trackingId: string) {
    if (trackingId) {
      this.trackingNumber = trackingId;
      this.trackingDisplayModal = true;
      this.showfilter = false;
    }
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  closeModalFregihtDetails() {
    this.showfilter = true;
    this.trackingDisplayModal = false;
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    const overlays = document.querySelectorAll<HTMLElement>(
      ".p-datatable-filter-overlay"
    );

    if (overlays && overlays.length > 0) {
      let clickedInsideOverlay = false;
      overlays.forEach(overlay => {
        if (overlay.contains(event.target as Node)) {
          clickedInsideOverlay = true;
        }
      });
      if (!clickedInsideOverlay) {
        overlays.forEach(overlay => overlay.remove());
      }
    }
  }
}
